import {useState, useCallback, Fragment} from "react";
import {Link as RouterLink} from "react-router-dom";

import {Box, Fab, IconButton, Link, Menu, MenuItem,Toolbar,Typography } from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import {SITES_ROUTE} from "../lib/routes";
import ScrollTop, {BackToTopAnchor} from "./ScrollTop";

import logo from "../assets/logo.svg";
import logoNatale from "../assets/LogoCloudControlPrinc1-natale.svg"
import scrittaNatale from "../assets/LogoCloudControlScritta-natale.svg"
// import scrittaPasqua from "../assets/LogoCloudPasqua.svg"
import scritta from "../assets/soloScritta.svg"
import { AppBarCustom } from "../Theme/AppBar";
import { LogoCustom } from "../Theme/ImageStyle";
import { ContainerCustom4 } from "../Theme/ContainerStyle";
import { useAuth } from "../hooks/useAuthProvide";
import { useHelp } from "../hooks/useHelpProvide";
import { HelpIcon } from "./IconCustom";

export default function Page({lastChildren, children, maxWidth = "lg"}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const {logout} = useAuth();
  const {startTour, stopTour, tourStarted} = useHelp();

  // Determina se siamo nel periodo natalizio (dall'8 dicembre al 6 gennaio)
  const now = new Date();
  const month = now.getMonth(); // 0=Gennaio, 11=Dicembre
  const day = now.getDate();

  // Logica per determinare se mostrare logo natalizio
  // Se mese = Dicembre (11) e giorno >= 8
  // oppure se mese = Gennaio (0) e giorno <= 6
  // allora mostra logo natalizio
  const isChristmasTime = 
    (month === 11 && day >= 8) ||  // Dicembre dall'8 in poi
    (month === 0 && day <= 6);     // Gennaio fino al 6

  const currentLogo = isChristmasTime ? logoNatale : logo;
  const currentScritta = isChristmasTime ? scrittaNatale : scritta;

  const handleMenu = useCallback((event) => setAnchorEl(event.currentTarget), []);
  const handleClose = useCallback(() => setAnchorEl(null), []);
  const onLogout = useCallback(() => logout(), [logout]);
  const onStartTour = useCallback(() => {
    setAnchorEl(null);
    startTour();
  },[startTour]);

  return (
    <Fragment>
      <AppBarCustom>
        <Toolbar>
          <Typography variant="h5" sx={{flexGrow: 1, fontWeight: 'fontWeightLight'}}>
            <Link component={RouterLink} to={SITES_ROUTE.path} underline="none">
              <LogoCustom src={currentLogo} alt="CloudControl Logo" />
              <LogoCustom src={currentScritta} alt="CloudControl Logo" visible/>
            </Link>
          </Typography>
          <HelpIcon tourStarted={tourStarted} stopTour={stopTour}/>
          <Box>
            <IconButton onClick={handleMenu} color="primary">
              <AccountCircle />
            </IconButton>
            <Menu id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{ vertical: "top", horizontal: "right"}}
                  keepMounted
                  transformOrigin={{ vertical: "top", horizontal: "right"}}
                  open={open}
                  onClose={handleClose}>
              <MenuItem onClick={onStartTour}>Aiuto</MenuItem>
              <MenuItem onClick={onLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBarCustom>
      <BackToTopAnchor />
      <ContainerCustom4 maxWidth={maxWidth}>
        {children}
      </ContainerCustom4>
      <ScrollTop >
        <Fab color="primary"  style={{ margin: "10px"}}>
          <KeyboardArrowUpIcon/>
        </Fab>
      </ScrollTop>
      {lastChildren}
    </Fragment>
  );
}
